/**
 * FaqAccordion.tsx — spørsmål og svar (Carbon Accordion-utseende)
 *
 * Bygget på native <details>/<summary>: tastatur, skjermleser og åpne/lukke
 * fungerer uten JavaScript. Stilen følger Carbon Accordion (flush, tynne
 * skillelinjer, chevron som roterer).
 */

import { ChevronDown } from '@carbon/icons-react';
import type { ProductFaqSection } from '@/types/product';
import SectionHeader from './SectionHeader';
import styles from './product.module.css';

export default function FaqAccordion({ faq }: { faq: ProductFaqSection }) {
  return (
    <section id="sporsmal" className={styles.sectionAlt} aria-labelledby="faq-heading">
      <div className={styles.container}>
        <SectionHeader id="faq-heading" eyebrow={faq.eyebrow} heading={faq.heading} />

        <div className={styles.accordion}>
          {faq.items.map((item) => (
            <details key={item.question} className={styles.item}>
              <summary className={styles.summary}>
                <span>{item.question}</span>
                <ChevronDown size={20} aria-hidden className={styles.chevron} />
              </summary>
              <p className={styles.answer}>{item.answer}</p>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}
